<layout *ngIf="profile">
    <button [@visible] *ngIf="shouldDisplay" class="banner" (click)="turnOnNotifications()">
    <p>{{config?.emailNotificationsOffWarning}}</p>
    </button>
</layout>
